import { ChangeEvent, DataHeader, DataSourceMode, Snackbar } from "@mcleod/components";
import { Api } from "@mcleod/core";
import { AutogenLayoutBackOfficeReasonCode } from "./autogen/AutogenLayoutBackOfficeReasonCode";
import { DuplicateId, DuplicateIdProps } from "@mcleod/dispatch";


const viewBackOffReasonCodeURL = "lme/settlement/BackOfficeReasonCode?mode=update&key=";
const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName: "ar_reason_code",
    screenName: "Back Office Reason Code",
    navigateToUrl: viewBackOffReasonCodeURL
};
export class BackOfficeReasonCode extends AutogenLayoutBackOfficeReasonCode {

    onLoad(): void | Promise<void> {
        DuplicateId.configureIdTextbox(this.textboxId, DUPLICATE_VALIDATION_PROPS);
    }

    public override doAfterDataHeaderSetup(dataHeader: DataHeader): void {
        dataHeader.showDelete = true;
    }

    switchIsActiveOnChange(event: ChangeEvent) {
        if (this.sourceBackOfficeReasonCode.mode == DataSourceMode.UPDATE) {
            if (event.userInitiatedChange) {
                const additionalSettings = this.switchIsActive.checked;

                Api.post("lme/settlement/check-if-back-office-reason-code-in-use", { back_office_reason_code: this.activeRow.get("id") }).then(response => {
                    if (response?.data[0]?.in_use) {
                        Snackbar.showWarningSnackbar("The Back Office Reason Code is currently in use on a settlement.");
                        this.switchIsActive.checked = true;
                    }
                });
            }
        }
    }
}
